export default class PatchAsistencia {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idAsistencia, payload) {
    try {
      const result = await this.#repository.patchAsistencia(idPersonal, idAsistencia, payload)
      return result
    } catch (error) {
      console.error('Error al actualizar la asistencia:', error)
      throw error
    }
  }
}
